import { createUseStyles } from 'react-jss';

/* Adding or removing divs from claimsCount mapping will affect CSS - change carefully */
export const useStyles = createUseStyles(() => ({
    claims_detail_main: {
        marginTop: '-2.5rem',
        marginBottom: '4rem'
    },
    atfault_radio_group: {
        width: '100%',
        marginBottom: '1.2rem'
    },
    timeframe_radio_group: {
        width: '100%',
        marginBottom: '1.2rem'
    },

    buttonContainer: {
        display: 'flex'
    },

    container: {
        display: 'flex',
        flexDirection: 'row',
        width: '75%'
    },
    claimLabel: {
        fontSize: '1.6rem',
        color: '#25130e',
        marginBottom: '1rem',
        '& div[role=tooltip]': {
            color: 'rgba(0, 0, 0, 0.5)'
        }
    },

    title: {
        fontSize: '1.8rem',
        fontWeight: 600,
        marginBottom: '1rem'
    },
    subtitle: {
        fontWeight: 400,
        marginLeft: '0.5rem'
    },

    excess_paid_radio_group: {
        display: 'flex',
        width: '100%'
    },
    '@media (min-device-width: 280px) and (max-device-width: 767px)': {
        container: {
            width: '100%'
        }
    }
}));
